import { render, staticRenderFns } from "./ViewLeaderboard.vue?vue&type=template&id=2b988638&"
import script from "./ViewLeaderboard.vue?vue&type=script&lang=js&"
export * from "./ViewLeaderboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports